import script from "./SearchResult.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResult.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResult.vue?vue&type=style&index=0&id=7d8bd632&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d8bd632"]])

export default __exports__